import { createFileRoute } from '@tanstack/react-router';
import { mcpRouteOptions } from '../-workspaceRouteOptions';

export const Route = createFileRoute('/_authed/$orgSlug/mcp')({
  ...mcpRouteOptions,
});
